<div class="fn-root" (pointerdown)="$event.stopPropagation()">
  <div class="label">formula</div>
  <select class="select" [value]="data.fn" (change)="changeFn(($any($event.target)).value)">
    <option value="alias">alias</option>
    <option value="substring">substring</option>
    <option value="sepstring">sepstring</option>
    <option value="joinstring">joinstring</option>
    <option value="datestring">datestring</option>
    <option value="format">format</option>
    <option value="case">case</option>
    <option value="array">array</option>
    <option value="calc">calc</option>
    <option value="round">round</option>
    <option value="ceiling">ceiling</option>
    <option value="floor">floor</option>
    <option value="count">count</option>
    <option value="sum">sum</option>
    <option value="min">min</option>
    <option value="max">max</option>
    <option value="rowNo">rowNo</option>
    <option value="viewNo">viewNo</option>
    <option value="expandNo">expandNo</option>
    <option value="listagg">listagg</option>
    <option value="guid">guid</option>
    <option value="ulid">ulid</option>
    <option value="now">now</option>
    <option value="iif">iif</option>
  </select>

  @if (data.fn === 'round' || data.fn === 'ceiling' || data.fn === 'floor') {
    <div class="label2">digits</div>
    <input class="text" type="number" [value]="data.digits ?? 0" (input)="changeDigits(($any($event.target)).value)" />
  }

  @if (data.fn === 'joinstring') {
    <div class="label2">joinChar</div>
    <input class="text" [value]="data.joinChar ?? '-'" (input)="changeJoinChar(($any($event.target)).value)" placeholder="-" />
  }

  @if (data.fn === 'datestring') {
    <div class="label2">format</div>
    <input
      class="text"
      [value]="data.dateFormat ?? 'yyyyMMdd'"
      (input)="changeDateFormat(($any($event.target)).value)"
      placeholder="yyyyMMdd"
    />
  }

  @if (data.fn === 'listagg') {
    <div class="label2">options</div>
    <select class="select" [value]="data.listaggOptions ?? 'list'" (change)="changeListaggOptions(($any($event.target)).value)">
      <option value="list">list</option>
      <option value="distinct">distinct</option>
    </select>
  }
</div>

